import { render, staticRenderFns } from "./SortingMenu.vue?vue&type=template&id=52b4f271&scoped=true"
import script from "./SortingMenu.vue?vue&type=script&lang=js"
export * from "./SortingMenu.vue?vue&type=script&lang=js"
import style0 from "./SortingMenu.vue?vue&type=style&index=0&id=52b4f271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4f271",
  null
  
)

export default component.exports